module.exports = __webpack_public_path__ + "img/capsule-toy-purple.26f43f81.png";